import { NextSeo } from 'next-seo'

const SEO = props => <NextSeo {...props} />

export default SEO
